import { configure } from "mobx";
import { getReactiveLayer } from "./reactive-layer";

configure({ isolateGlobalState: true });

export { getReactiveLayer };
